import React from "react";
//import CssClasses from "./Advertisement.css";
//import logo from "../../assets/images/wwin_logo.png";
import adVideo from "../../assets/images/screen_ad.swf";

const Advertisement = props => {
  return (
    <div>
      <embed src={adVideo} width="1080" height="1920" />
    </div>
  );
};


export default Advertisement;



// WEBPACK FOOTER //
// ./src/HOCs/Advertisement/Advertisement.js